import React from "react";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";
import { login, fundedInvoicesData, PROCESSING_HOURS } from "../../locales/en";
import Style from "./modal.module.scss";
import "../../assets/scss/common.scss";
import { isWeekendNZT, isWeekendAEST } from "../../utils/utils";
import { COUNTRY_CODE_AU } from "../../utils/constants/appConstants";

const isOutsideProcessingHours = (country, now = new Date()) => {
  const { openHour, closeHour } =
    PROCESSING_HOURS[country] || PROCESSING_HOURS.NZ;
  const isWeekend =
    country === COUNTRY_CODE_AU ? isWeekendAEST(now) : isWeekendNZT(now);
  return isWeekend || now.getHours() < openHour || now.getHours() >= closeHour;
};

const AcceptQuoteInvoiceModal = ({ isOpen, toggle, user }) => {
  const showOutOfHoursNote = isOutsideProcessingHours(
    user?.userAccountMeta?.primaryCountry
  );

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={login?.mainTitle2}
      modalClassName={`${Style.xeroModal} modal-lg`}
      headerClassName={Style.creditModalHeader}
      bodyClassName={`${Style.manualUploadContent} modal-content border-0 mb-3`}
      hideFooter
    >
      <div className="inv-upload-template">
        <div className={`${Style.manul_Invoice_Submit} ps-0`}>
          <p>{fundedInvoicesData?.AcceptQuoteInvoiceModal?.text1}</p>
          {showOutOfHoursNote && (
            <p>
              <sub>
                {fundedInvoicesData?.AcceptQuoteInvoiceModal?.outOfHoursNote}
              </sub>
            </p>
          )}
        </div>
      </div>
    </CommonModal>
  );
};

AcceptQuoteInvoiceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  user: PropTypes.any
};

export default AcceptQuoteInvoiceModal;
